import React from "react";

export default function ListBlock({ data }) {
  const items = data.items || ["List item 1", "List item 2"];

  return (
    <div style={{ padding: "20px", background: "#1d1d1d", color: "white", borderRadius: "12px", marginTop: "20px" }}>
      <h2>{data.title || "List Block"}</h2>
      <ul style={{ marginTop: "10px" }}>
        {items.map((item, i) => (
          <li key={i} style={{ padding: "5px 0" }}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
